
import { Prop } from 'vue-property-decorator'
import { Vue, Options } from 'vue-class-component'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faXmark } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { isExactString } from '@/utils/object'
import { useStore } from '@/store'
import { mapState } from 'vuex'
import { TieredPoint } from '@/interfaces/customer-info'
import { getDate } from '@/helpers/date'
import { getDisplayPoint } from '@/utils/functions'

library.add(faXmark)

@Options({
  components: {
    FontAwesomeIcon,
  },
  computed: {
    ...mapState({
      tieredPoints: (state: any) => state.customer.tieredPoints,
    }),
  },
})
export default class ModalBottomTieredPoints extends Vue {
  @Prop() onClose!: () => void;
  store = useStore();
  private tieredPoints: TieredPoint[] | undefined =
    this.store.state.customer.tieredPoints;
  private active = true;

  mounted() {
    this.setOpacity()
  }

  setOpacity() {
    const modalElement = document.getElementsByClassName(
      'dummy-background-tiered-points'
    )[0]! as HTMLElement
    setTimeout(() => {
      modalElement.style.opacity = '0.7'
    }, 10)
  }

  closeModal() {
    const dialogElement = document.getElementsByClassName(
      'modal-dialog-tiered-points'
    )[0]! as HTMLElement
    const modalElement = document.getElementsByClassName(
      'dummy-background-tiered-points'
    )[0]! as HTMLElement

    dialogElement.style.bottom = '-100%'
    modalElement.style.opacity = '0'

    setTimeout(() => {
      this.onClose()
    }, 500)
  }

  onClickOutside(event: any) {
    const elClassName = event.target.className
    if (isExactString(elClassName)) {
      this.closeModal()
      this.store.dispatch('modalTieredPoints/onClose', false)
    }
  }

  getLabelPoints(point: string): string {
    const expiringPoints = parseFloat(point)
    const points = getDisplayPoint(expiringPoints)

    return `${points} คอยน์`
  }

  getLabelDate(date: string): string {
    return `หมดอายุ ${getDate(date, 'DD MMM BBBB')}`
  }
}
